// KL - aircond leaking water (problem page).
const content = {
    slug: 'aircond-leaking-water',
    title: 'Aircond Leaking Water in KL? Why It Happens and How to Fix It',
    description: (c) =>
        `Aircond dripping water? Usually a blocked drain pipe in KL's humidity. Drain flush from ${c.money(c.tables.drainFlush[0].price)}; general service from ${c.money(c.tables.general[0].wall)}.`,
    eyebrow: 'KL · Aircond leaking water',
    h1: 'Aircond Leaking Water?',
    lead: 'In KL\'s humidity your aircond pulls a lot of water out of the air every night. When the drain can\'t carry it away, it drips onto your bed, floor or wall. Here\'s why it happens and how it\'s fixed.',
    image: 'blog/living/aircon-leaking-water.jpg',
    imageAlt: 'Water dripping from a wall-mounted aircond',
    facts: ['Usually a blocked drain', 'Fixed in one visit', 'Protect your walls'],
    ctaLabel: 'Book a drain flush',
    priceTitle: 'Drain flush prices',
    priceIntro: 'Clears the drain tray and pipe. If the coil is dirty too, add a general service - the technician advises on the day.',
    panel: { type: 'drainFlush' },
    sections: [
        {
            title: 'Why aircond leaks in Malaysian homes',
            cards: [
                { title: 'Blocked drain pipe', body: 'Dust and slime from the coil wash into the drain and block it. Most common cause.' },
                { title: 'Sagging or kinked pipe', body: 'The drain pipe needs a downhill slope all the way out. Renovation or a loose clip can create a dip where water sits.' },
                { title: 'Frozen coil', body: 'A clogged filter or low gas freezes the coil; when it melts, the tray overflows.' },
                { title: 'Unit not level', body: 'If the indoor unit tilts the wrong way, water runs out of the tray before it reaches the drain.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'While you wait for the technician',
            tone: 'muted',
            items: [
                'Switch the unit off - it stops making water.',
                'Move the bed, laptop or anything valuable away from below the unit.',
                'Lay a towel or tray under the drip.',
                'Check the drain pipe outlet outside or on the ledge - if it\'s blocked by leaves or a plant pot, clearing it may solve it.',
            ],
        },
        {
            title: 'Leaks cause damage you don\'t see straight away',
            paragraphs: [
                'Water running down the inside of a wall soaks plaster, lifts paint and grows mould behind wardrobes. In condos it can reach the unit below. A drain flush costs far less than repainting a wall - book it when you first see a drip.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Why is my aircond leaking water?',
            answer: 'Usually because the drain pipe is blocked with slime and dust. A drain flush clears it. Other causes are a sagging pipe, a frozen coil or a unit that isn\'t level.',
        },
        {
            question: 'How much does it cost to fix a leaking aircond in KL?',
            answer: (c) => `A drain flush costs ${c.money(c.tables.drainFlush[0].price)} for one unit. A general service, which also clears the drain, costs ${c.money(c.tables.general[0].wall)}.`,
        },
        {
            question: 'Is it safe to keep using a leaking aircond?',
            answer: 'Switch it off if water is near a socket or electrics. Otherwise, catch the water and book a service soon - the leak usually gets worse.',
        },
    ],
    schema: {
        name: 'Aircond Leak Repair in Kuala Lumpur',
        serviceType: 'Air conditioner drain cleaning',
        offers: (c) => [
            { name: 'Drain flush, 1 unit', price: c.tables.drainFlush[0].price },
            { name: 'Drain flush, 2 units', price: c.tables.drainFlush[1].price },
        ],
    },
}

export default content
